module.exports = __webpack_public_path__ + "static/request-img-placeholder2-e311f806fda6498c49079592ba83f71b.jpg";